export default __webpack_public_path__ + "static/Eurowings-Holidays_1_1_en-8fdcf2762d476e09988e49aed835f4bc.png";